// @flow
import React from 'react';
import { Grid } from 'semantic-ui-react';
import { StyledHeader } from '@src/common-utils/styledComponents';
import { getMetricDimensionsLabelsFromMetricName } from '@streaming-projects/user-commit-details/committed-capacity/utils';
import { COMMITTED_CAPACITY } from '@streaming-projects/user-commit-details/committed-capacity/enums';

export const DimensionHeadersContainer = ({ metricName }) => {
  const dimensionHeaderNames = [
    ...getMetricDimensionsLabelsFromMetricName(metricName),
    COMMITTED_CAPACITY.QUANTITY_DISPLAY_NAME,
  ];

  return (
    <Grid.Row>
      {dimensionHeaderNames.map((colName) => {
        return (
          <Grid.Column key={colName} width={3}>
            <StyledHeader size="tiny">{colName}</StyledHeader>
          </Grid.Column>
        );
      })}
    </Grid.Row>
  );
};
